module.exports = __webpack_public_path__ + "assets/chizi.5a4a8fda.svg";